/* La Table des Cimes — ambiance jazz (remplace le son de cheminée)
   Musique : Pixabay Content License (usage libre, sans attribution obligatoire).
   Volume volontairement bas (ambiance restaurant), fondu d'entrée, démarre au premier geste du visiteur
   (les navigateurs interdisent le son automatique), bouton pour couper, choix mémorisé. */
(function(){
  if(window.Shopify&&Shopify.designMode)return;
  var me=document.currentScript;
  var LIST=((me&&me.getAttribute('data-tracks'))||'').split('|').filter(Boolean);
  if(!LIST.length)return;
  var GAIN=0.13;                      /* ≈ -18 dB : fond sonore discret */
  var lang=(document.documentElement.lang||'fr').slice(0,2);
  function T(fr,en,ru){return lang==='en'?en:lang==='ru'?ru:fr;}
  var store={get:function(k){try{return localStorage.getItem(k);}catch(e){return null;}},
             set:function(k,v){try{localStorage.setItem(k,v);}catch(e){}}};
  var want=store.get('tdc-music')!=='off';
  var idx=Math.floor(Math.random()*LIST.length);
  var au=new Audio();au.crossOrigin='anonymous';au.preload='none';au.setAttribute('playsinline','');
  au.loop=LIST.length===1;au.src=LIST[idx];
  au.addEventListener('ended',function(){idx=(idx+1)%LIST.length;au.src=LIST[idx];if(want)au.play().catch(function(){});});
  var ctx=null,g=null;
  function graph(){
    if(ctx)return;
    var AC=window.AudioContext||window.webkitAudioContext;
    if(!AC){au.volume=GAIN;return;}
    try{ctx=new AC();var src=ctx.createMediaElementSource(au);g=ctx.createGain();g.gain.value=0;src.connect(g);g.connect(ctx.destination);}
    catch(e){ctx=null;au.volume=GAIN;}
  }
  function fade(to,s){
    if(g&&ctx){var t=ctx.currentTime;g.gain.cancelScheduledValues(t);g.gain.setValueAtTime(g.gain.value,t);g.gain.linearRampToValueAtTime(to,t+s);}
    else au.volume=to;
  }

  var btn=document.createElement('button');btn.type='button';btn.className='tdc-snd';
  btn.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="#D9A84E" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18V5l11-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="17" cy="16" r="3"/></svg>'
    +'<span class="tdc-snd__eq" aria-hidden="true"><i></i><i></i><i></i><i></i></span>'
    +'<svg class="tdc-snd__off" viewBox="0 0 24 24" fill="none" stroke="rgba(245,241,232,.6)" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M4 4l16 16"/></svg>'
    +'<span class="tdc-snd__lbl">'+T('Ambiance jazz','Jazz ambience','Джаз')+'</span>';
  document.body.appendChild(btn);

  function on(){return !au.paused;}
  function ui(){
    var p=want&&on();
    btn.classList.toggle('is-on',p);btn.classList.toggle('is-off',!want);btn.classList.toggle('is-wait',want&&!p);
    btn.setAttribute('aria-pressed',want?'true':'false');
    btn.setAttribute('aria-label',want?T('Couper la musique','Turn off the music','Выключить музыку'):T('Mettre la musique','Turn on the music','Включить музыку'));
  }
  ['play','playing','pause'].forEach(function(t){au.addEventListener(t,ui);});
  function play(){
    if(!want)return;
    graph();
    if(ctx&&ctx.state==='suspended'){try{ctx.resume();}catch(e){}}
    var p=au.play();
    var ok=function(){fade(GAIN,3);ui();off();};
    if(p&&p.then)p.then(ok,ui);else ok();
  }
  function stop(){fade(0,.6);setTimeout(function(){if(!want)au.pause();ui();},650);}

  var evs=['pointerdown','touchend','click','keydown'];
  function gesture(e){if(btn.contains(e.target))return;if(!want){off();return;}play();}
  function off(){evs.forEach(function(t){document.removeEventListener(t,gesture,true);});}
  evs.forEach(function(t){document.addEventListener(t,gesture,true);});

  btn.addEventListener('click',function(e){
    e.stopPropagation();
    if(want&&!on()){play();return;}
    want=!want;store.set('tdc-music',want?'on':'off');
    if(want)play();else stop();
    ui();
  });
  var was=false;
  document.addEventListener('visibilitychange',function(){
    if(document.hidden){was=on();if(was){fade(0,.3);setTimeout(function(){au.pause();},350);}}
    else if(want&&was){play();}
  });
  ui();
})();